/**
 * Enum values are string-numbers because they represent the parsed values from the puzzle xml file
 */
export enum PuzzleFrameworkEvents {
  SHOW_HELP_BADGE,
  SOLVE_CURRENT_PUZZLE,
  SOLVE_CURRENT_PUZZLE_BUT_ONE,
  ALMOST_SOLVE_CURRENT_PUZZLE,
  PREVIOUS_QUESTION,
  NEXT_QUESTION,
  ADD_ALL_NOTES,
}
